import React from "react";
import { FaChevronLeft } from "react-icons/fa";

export const ProjectDetails = () => {
  return (
    <div className="project-details">
    <a className="back-to-projects" href="/projects">
              <span><FaChevronLeft /></span>
      <p>
      Back to projects
      </p>
</a>
      <h1 className="project-title-info">Miami Beach Project</h1>
      <h2  className="work-description">Residential Interior unit remodel</h2>
      <p className="work-details">New kitchen, bathrooms, flooring and plumbing.
In this project we worked with “fato su misura” they fabricated and installed the vanities and kitchen. 
</p>
    </div>
  );
};
